export default __webpack_public_path__ + "static/HP-howitworks1-481c72d11cf8525340d7812737074416.webp";